// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'browser';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.984.576H2.016c-.792 0-1.44.648-1.44 1.44v13.968c0 .792.648 1.44 1.44 1.44h13.968c.792 0 1.44-.648 1.44-1.44V2.016c0-.792-.648-1.44-1.44-1.44zM.576 4.248h16.92' />
    <path d='M14.76 6.48H9c-.216 0-.36.144-.36.36V9c0 .216.144.36.36.36h5.76c.216 0 .36-.144.36-.36V6.84c0-.216-.144-.36-.36-.36zm0 5.04H9c-.216 0-.36.144-.36.36v2.16c0 .216.144.36.36.36h5.76c.216 0 .36-.144.36-.36v-2.16c0-.216-.144-.36-.36-.36zM2.88 7.92h2.88M2.88 10.8h2.88m-2.88 2.88h2.88M3.096 2.592c-.072 0-.216-.072-.216-.216 0-.072.072-.216.216-.216m0 .432c.072 0 .216-.072.216-.216 0-.072-.072-.216-.216-.216m2.232.432c-.072 0-.216-.072-.216-.216 0-.072.072-.216.216-.216m0 .432c.072 0 .216-.072.216-.216 0-.072-.072-.216-.216-.216m2.232.432c-.072 0-.216-.072-.216-.216 0-.072.072-.216.216-.216m0 .432c.072 0 .216-.072.216-.216 0-.072-.072-.216-.216-.216' />
  </g>
);

export const viewBox = '0 0 18 18';
